var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#1f2923",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 2C9.68448 2 9.42865 2.25584 9.42865 2.57143V9.42852H2.57143C2.25584 9.42852 2 9.68435 2 9.99994C2 10.3155 2.25584 10.5714 2.57143 10.5714H9.42865V17.4286C9.42865 17.7442 9.68448 18 10.0001 18C10.3157 18 10.5715 17.7442 10.5715 17.4286V10.5714H17.4286C17.7442 10.5714 18 10.3155 18 9.99994C18 9.68435 17.7442 9.42852 17.4286 9.42852H10.5715V2.57143C10.5715 2.25584 10.3157 2 10.0001 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddLight);
export default __webpack_public_path__ + "static/media/add-light.f174eacec2c8a918672c830cbfe992d8.svg";
export { ForwardRef as ReactComponent };